import React from 'react';
import theme from './StatusReason.module.scss';
import { Tooltip } from '@/components/Tooltip';
import { Trans } from '@lingui/react/macro';
import { StatusReasonProps } from '.';

const StatusReason: React.FC<StatusReasonProps> = ({ reason, userName, titleGenerator }) => {
    const renderTooltipContent = () => {
        return (
            <div>
                <div className={theme.title}>
                    <Trans>Reason</Trans>
                </div>
                {reason ? (
                    <div className={theme.reason}>{reason}</div>
                ) : (
                    <div className="text-missing">
                        <Trans>No reason provided</Trans>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Tooltip dynamicWidth title={titleGenerator(userName)} content={renderTooltipContent()} className={theme.tooltip}>
            <span className={theme.label}>
                <Trans>Why?</Trans>
            </span>
        </Tooltip>
    );
};

export default StatusReason;
